import { render, staticRenderFns } from "./WaitingValuesAdd.vue?vue&type=template&id=8752f7ee&"
import script from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
export * from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
import style0 from "./WaitingValuesAdd.vue?vue&type=style&index=0&id=8752f7ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports